import React, { useState, useEffect } from "react"
import {  NavLink } from "react-router-dom"
import "./BottomNav.css"
import { useSelector } from "react-redux"
const Footer = () => {
  const pathname = window.location.pathname

  const [isKeyboardVisible, setKeyboardVisible] = useState(false)
  const { bottomNavIcons } = useSelector(state => state.DashReducer)

  useEffect(() => {
    const handleResize = () => {
      const windowHeight = window.innerHeight
      const initialHeight = window.screen.height
      const keyboardThreshold = 100 // Adjust as needed
      setKeyboardVisible(initialHeight - windowHeight > keyboardThreshold)
    }

    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  return (
    <React.Fragment>

      {!isKeyboardVisible ? (
        <footer className="bottomNavbar no-printme">
          <nav className="mobile-bottom-nav">
            {bottomNavIcons &&
              bottomNavIcons.length > 0 &&
              bottomNavIcons.map((icons, index) => (
                <NavLink
                  to={icons.url}
                  key={index}
                  className={`mobile-bottom-nav__item ${
                    pathname === icons.url ? "text-primary" : "text-dark"
                  }`}
                >
                  <div className="mobile-bottom-nav__item-content">
                    <i className={`${icons.icon} mobile-bottom-nav_icon`} />
                    {icons.NAME}
                  </div>
                </NavLink>
              ))}
          </nav>
        </footer>
      ) : null}
    </React.Fragment>
  )
}

export default Footer
